import {QuestionResult, QuizQuestion} from "../MarginQuizQuestions";
import {ComponentCallback} from "../../../types/AngularJS";
import {QuizQuestionAnswer} from "../../../components/quiz/models/QuizQuestionAnswer";
import {ArrayUtil} from "../../../js/util/ArrayUtil";
import {StringKeyed} from "../../../types/GenericTypes";
import {IOnInit} from "angular";
import {Optional} from "../../../js/util/Optional";

export abstract class MarginQuizQuestionController implements IOnInit {

    public abstract config: QuizQuestion;

    public previousAnswers: StringKeyed<Array<string>>;
    public previousAnswer: Array<string> | null;
    public onAnswer: ComponentCallback;

    public $onInit(): void {
        this.previousAnswer = Optional.of(this.previousAnswers)
                                      .map(pa => pa[this.config.name])
                                      .orNull();
    }

    public answered(answer: QuizQuestionAnswer) {
        const correctAnswer = this.correctAnswers();
        const isCorrect = ArrayUtil.matches(correctAnswer, answer.answers);
        const result: QuestionResult = {
            question: this.config,
            correct: isCorrect,
            answer: answer.answers
        };
        this.onAnswer({answer: result});
    }

    private correctAnswers(): Array<string> {
        const answers = this.config.answers;
        return Object.keys(answers).filter(key => answers[key]);
    }
}
